import { Component, OnInit, ViewChild } from "@angular/core";
import { GraphQLClient } from '../../../shared/services/graph-qlclient.service';
import gql from 'graphql-tag';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { categoria_modulo } from '../../../shared/object/categoria_modulo.model';
import { modulo } from '../../../shared/object/modulo.model';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';

@Component({
  selector: "app-categorias",
  templateUrl: "./categorias.component.html",
  styleUrls: ["./categorias.component.scss"],
  providers: [SecurityService, ValidadoresService]
})
export class CategoriasComponent implements OnInit {
  private client: GraphQLClient = null;
  categoria_moduloList: categoria_modulo[];
  selectedCategoriaModulo: categoria_modulo;
  categoria_modulo: categoria_modulo;
  public nombre:string;
  formulario: FormGroup;
  moduloList:modulo[];
  moduloCategoriaList:modulo[];
  optionsModulo: Array<any> = [];
  @ViewChild('agregarCategorias', { static: true }) agregarModal: ModalDirective;
  @ViewChild('editarCategorias', { static: true }) editarModal: ModalDirective;
  public codgo_modulo:number = 22;
  public rut_usuario =  Number(this.accesolocalstorage.getRutUsuario());



  constructor(client: GraphQLClient, 
    private formBuilder: FormBuilder,
    private accesolocalstorage: SecurityService,
    public validadores: ValidadoresService ) {
    this.client = client;
    this.buildForm();
  }
  buildForm() {
    this.formulario = this.formBuilder.group({
      codigo: [0],
      nombre: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(50)]],
      icono: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(30)]],
      activado: [true],
      orden:[[Validators.required], Validators.min(1)],
      modulo: [''],
    });
  }

  ngOnInit() {
    this.selectedCategoriaModulo = {
      codigo:0,
      nombre: '',
      icono: '',
      activado: true,
      fecha_creacion: new Date(),
      orden:0
    };
    this.obtenerDatosCategoria();
  }

  showNew() {
    this.formulario.reset();
    this.formulario.get('activado').setValue(true);
    this.moduloCategoriaList= [];
    this.obtenerModulos()
  }

  showForEdit(categoria_modulo: categoria_modulo) {
    this.formulario.get('codigo').setValue(categoria_modulo.codigo);
    this.formulario.get('nombre').setValue(categoria_modulo.nombre);
    this.formulario.get('icono').setValue(categoria_modulo.icono);
    this.formulario.get('activado').setValue(categoria_modulo.activado);
    this.formulario.get('orden').setValue(categoria_modulo.orden);
    this.formulario.get('modulo').setValue("");
    this.moduloList=[];
    this.obtenerModulos()
    this.obtenerModuloCategoria(categoria_modulo.codigo);
  }

  obtenerDatosCategoria() {
    let self = this;
    this.client.query({
      query: gql`
      query {
        categoria_modulo{
          obtenerTodos{
            respuesta{
              registros{
                codigo
                nombre
                icono
                activado
                fecha_creacion
                orden
              }
            }
          }
        }
      }
      `,
      fetchPolicy: 'no-cache',
    },
    function(respuesta) {
      self.categoria_moduloList = respuesta.data.categoria_modulo.obtenerTodos.respuesta.registros;
    });
  }

  obtenerModulos() {
    let self = this;
    this.client.query({
      query: gql`
      query {
        modulo{
          obtenerTodos{
            respuesta{
              registros{
                codigo
                categoria_modulo_codigo
                nombre
                activado
                fecha_creacion
                endpoint
                orden
              }
            }
          }
        }
      }
      `,
      fetchPolicy: 'no-cache',
    }, function(respuesta) {
      self.moduloList = respuesta.data.modulo.obtenerTodos.respuesta.registros;
      self.optionsModulo = [];
      var sel: any;
      self.moduloList.forEach(element => {
        if(element.activado == true){
          sel = { value: element.codigo, label: element.nombre };
          self.optionsModulo.push(sel);
        }
      });
    });
  }

  insertar(moduloCategoriaList: modulo[]) {
    this.selectedCategoriaModulo.codigo = this.formulario.controls["codigo"].value;
    this.selectedCategoriaModulo.nombre = this.formulario.controls["nombre"].value;
    this.selectedCategoriaModulo.icono = this.formulario.controls["icono"].value;
    this.selectedCategoriaModulo.activado = this.formulario.controls["activado"].value;
    this.selectedCategoriaModulo.orden = this.formulario.controls["orden"].value;
    this.postCategoriaModulo(this.selectedCategoriaModulo, moduloCategoriaList);
  }

  postCategoriaModulo(categoria_modulo: categoria_modulo, moduloCategoriaList: modulo[]) {
    let self = this;
    var bodyx = categoria_modulo;
    this.client.mutate({
      mutation: gql`
      mutation($entidad: categoria_moduloInputType)
      {
        categoria_modulo{
          agregar(entidad: $entidad) {
            respuesta{
              codigo
              nombre
              icono
              activado
              fecha_creacion
              orden
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      }
    },
      function (respuesta) {
        if (respuesta.data.categoria_modulo.agregar.respuesta != undefined) {
          setTimeout(() => self.obtenerDatosCategoria(), 1000);
          let codigo_categoria = respuesta.data.categoria_modulo.agregar.respuesta.codigo;
          self.insertarModulo(moduloCategoriaList, codigo_categoria);
        }
      });
  }

  insertarModulo(moduloCategoriaList: modulo[], codigo_categoria:number) {
    for (var i = 0; i < moduloCategoriaList.length; i++) {
      moduloCategoriaList[i].categoria_modulo_codigo= codigo_categoria;
      delete moduloCategoriaList[i]["__typename"];
     }
     let self = this;
     var bodyx =  moduloCategoriaList;
     this.client.mutate({
      mutation: gql`
      mutation($entidad:moduloListInputType, $codigo_categoria:Decimal){
        modulo{
          guardarModuloxCategoria(entidad:$entidad, codigo_categoria:$codigo_categoria){
            mensajes{
              codigo
              tipo
              contexto
              texto
            }  
          }
        }
      }
      `,
      variables: {
        "entidad": {
          "objet":bodyx
        },
        "codigo_categoria": codigo_categoria
      }
    },
    function (mensajes) {
      if (mensajes.data.modulo.guardarModuloxCategoria.mensajes != undefined) {
        setTimeout(() => self.obtenerModuloCategoria(codigo_categoria), 1000);
      }
    });
  }

  obtenerDatosSegunFiltro(filtro_nombre:string) {
    let self = this;
    if (filtro_nombre != undefined){
      var bodyx = {
        nombre:filtro_nombre
      };
    }else{
      filtro_nombre ='';
      var bodyx = {
        nombre:filtro_nombre
      };
    }
    this.client.mutate({
      mutation: gql`
      query ($entidad:categoria_moduloInputType){
        categoria_modulo{
          obtenerSegunFiltro(filtro:{
            exacto:$entidad
          })
          {
            respuesta
            {
              registros
              {
                codigo
                nombre
                icono
                activado
                fecha_creacion
                orden
              }
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      }
    },
      function (respuesta) {
        self.categoria_moduloList = respuesta.data.categoria_modulo.obtenerSegunFiltro.respuesta.registros;
      });
  }
  actualizar(moduloCategoriaList: modulo[])
  {
      this.selectedCategoriaModulo.codigo = this.formulario.controls["codigo"].value;
      this.selectedCategoriaModulo.nombre = this.formulario.controls["nombre"].value;
      this.selectedCategoriaModulo.icono = this.formulario.controls["icono"].value;
      this.selectedCategoriaModulo.activado = this.formulario.controls["activado"].value;
      this.selectedCategoriaModulo.orden = this.formulario.controls["orden"].value;
      this.refrescar(this.selectedCategoriaModulo);
      this.refrescarModulo(moduloCategoriaList);
  }

  refrescar(categoria_modulo: categoria_modulo) {
    let self = this;
    var bodyx = categoria_modulo;
    delete categoria_modulo["__typename"];
    this.client.mutate({
      mutation: gql`
      mutation($entidad: categoria_moduloInputType)
      {
        categoria_modulo
        {
          modificar(entidad: $entidad) {
            mensajes{
              codigo
              contexto
              texto
              tipo
            }
            respuesta{
              nombre
              icono
              activado            
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      }
    },
      function (respuesta) {
        if (respuesta.data.categoria_modulo.modificar.respuesta == null) {
          if (respuesta.data.categoria_modulo.modificar.mensajes.length > 0) {
            alert(respuesta.data.categoria_modulo.modificar.mensajes[0].texto);
          }
        }
        setTimeout(() => self.obtenerDatosCategoria(), 1000);
      });
  }

  cambiaEstado(categoria_modulo:categoria_modulo)
  {
    if (categoria_modulo.activado)
    {
      categoria_modulo.activado = false; 
    }
    else
    {
      categoria_modulo.activado = true;
    }
    this.refrescar(categoria_modulo);
  }

  obtenerModuloCategoria(codigo_categoria:number){
    let self = this;
    self.client.query({
      query: gql`
      query($codigo_categoria:Decimal){
        modulo{
          obtenerModulosxCategorias(codigo_categoria:$codigo_categoria){
            respuesta{
              registros{
                codigo
                categoria_modulo_codigo
                nombre
                endpoint
                fecha_creacion
                activado
                orden
              }
            }
          }
        }
      }
      `,
      variables: {
        "codigo_categoria":codigo_categoria
      },
      fetchPolicy: 'no-cache',
    },
      function (respuesta) {
        self.moduloCategoriaList = respuesta.data.modulo.obtenerModulosxCategorias.respuesta.registros;
      });
  }

  refrescarModulo(moduloCategoriaList: modulo[]) {
    //console.log(moduloCategoriaList);
    let codigo_categoria = this.formulario.controls["codigo"].value;
    for (var i = 0; i < moduloCategoriaList.length; i++) {
      delete moduloCategoriaList[i]["__typename"];
     }
     let self = this;
     var bodyx =  moduloCategoriaList;
     this.client.mutate({
      mutation: gql`
      mutation($entidad:moduloListInputType, $codigo_categoria:Decimal){
        modulo{
          guardarModuloxCategoria(entidad:$entidad, codigo_categoria:$codigo_categoria){
          mensajes{
            codigo
            tipo
            contexto
            texto
          }  
          }
        }
      }
      `,
      variables: {
        "entidad": {
          "objet":bodyx
        },
        "codigo_categoria": codigo_categoria
      }
    },
    function (mensajes) {
      if (mensajes.data.modulo.guardarModuloxCategoria.mensajes != undefined) {
        setTimeout(() => self.obtenerModuloCategoria(codigo_categoria), 1000);
      }
    });
  }

  agregarModulo(){
    let nombre = "";
    let endpoint = "";
    let orden = 0;
    let activado = true;
    let codigo = this.formulario.controls["modulo"].value;
    var sel: any;
    var arr= [];
    let categoria_modulo_codigo= this.formulario.controls["codigo"].value;
    let fecha_creacion = new Date();
    if (codigo.toString() == "") {
      return;
    }
    this.moduloList.forEach(element=>{
      if(element.codigo == this.formulario.controls["modulo"].value){
        nombre = element.nombre;
        activado = element.activado;
        endpoint = element.endpoint;
        orden = element.orden;
      }
    });
    
    for (let item of this.moduloCategoriaList){
      arr = [item["codigo"], item["nombre"]]; 
      var idx = arr.indexOf(codigo);
      if(idx != -1){
        return;
      }
    }
    sel= { codigo, categoria_modulo_codigo, nombre, endpoint, orden, fecha_creacion, activado };
    this.moduloCategoriaList.push(sel);
    //console.log(this.moduloCategoriaList);
  }

  eliminarModulo(index){
    this.moduloCategoriaList.splice(index, 1);
  }
  showModalAgregar() {
    const self = this;
    let codigo_operacion = 3
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.agregarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  showModalModificar() {
    const self = this;
    let codigo_operacion = 2
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.editarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  permitirCambioEstado(categoria_modulo:categoria_modulo) {
    const self = this;
    let codigo_operacion = 4
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.cambiaEstado(categoria_modulo);
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
}
